import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled, { css } from "styled-components";

import { inertMaterials, defaultElement } from "./elements.js";
import RockMassField from "./RockMassField";
import Element from "./Element";
import AddElementButton from "./AddElementButton";
import RockValue from "./RockValue";
import ClearRockButton from "./ClearRockButton"
import isValidMass from "../../validators/mass";
import isValidPercentage from "../../validators/percentage";
import uuid from "../../utilities/uuid";
import {
    ResponsiveTable,
    ResponsiveFooter,
    ResponsiveCell
} from "../../ui/ResponsiveTable";

const Form = styled.form`
    font-size: 150%;
`;

const RockTable = styled(ResponsiveTable)`
    align-items: center;
`;

const RockTotals = styled(ResponsiveCell)`
    font-weight: bold;
    text-align: right;
`;

const ResponsiveHeader = styled(ResponsiveCell).attrs(props => ({
    break: props.break || "768px"
}))`
    @media all and (max-width: ${props => props.break}) {
        display: none;
    }
`;

//todo this needs defencing
const toFraction = (x) => x / 100;

const elementToRow = (element, percentage, value, id = uuid()) => ({
        ...element,
        elementId: element.id, 
        percentage,
        value,
        id
    });

const sumNonInertPercentages = (total, current) => {
    const percentage = Number.parseFloat(current.percentage);
    return (current.elementId != inertMaterials.id &&
        isValidPercentage(percentage))
        ? total + percentage
        : total;
}

const RockForm = () => {
    const defaultElements = [elementToRow(inertMaterials, 100, 0)];

    const [mass, setMass] = useState(0);
    const [elements, setElements] = useState(defaultElements);

    const handleAddElementClick = (event) => {
        event.preventDefault();
        const inert = elements.find((e) => e.elementId === inertMaterials.id);
        setElements([
            ...elements.filter((e) => e.elementId !== inertMaterials.id),
            elementToRow(defaultElement, 0, 0),
            inert
        ]);
    };

    const handleElementRemoved = (id) => {
        const elementsCopy = elements.filter((element) => element.id != id)
        setElements(elementsCopy);
    };

    const handleMassChange = (mass) => {
        setMass(mass);
    }

    const updateValues = () => {
        const elementsCopy = elements.map((e) => 
            ({...e, value: calculateValue(e)})
        );
        setElements(elementsCopy);
    };

    const copyInert = (element) => {
        const inert = {
            ...inertMaterials,
            percentage: 100 - elements.reduce(sumNonInertPercentages, 0),
            id: element.id,
            elementId: inertMaterials.id
        };
        inert.value = calculateValue(inert);
        return inert;
    };

    const handleElementChange = (element) => {
        element.value = calculateValue(element);
        const elementsCopy = elements.map((e) => {
            if (e.elementId == inertMaterials.id)
                return copyInert(e);
            else if (e.id == element.id)
                return element;
            else
                return e;
        });
        setElements(elementsCopy);
    }

    const calculateValue = (element) => {
        const percentage = Number.parseFloat(element.percentage)
        if (!isValidPercentage(percentage) || !isValidMass(mass))
            return 0.00;

        const elementMass = mass * toFraction(percentage);
        return elementMass * element.pricePerUnit;
    }

    useEffect(updateValues, [mass]);

    const elementRows = elements.map((element) =>
        <Element
            key={element.id}
            element={element}
            onElementChange={handleElementChange}
            onElementRemoved={handleElementRemoved} 
        />
    );

    return (
        <Form>
            <RockMassField mass={mass} onChange={handleMassChange} />
            <RockTable cols="4" style={{ marginTop: "24px" }}>
                <ResponsiveHeader width="40%">
                    Element
                </ResponsiveHeader>
                <ResponsiveHeader width="20%" style={{ textAlign: "right" }}>
                    Percent
                </ResponsiveHeader>
                <ResponsiveHeader width="20%" style={{ textAlign: "right", paddingRight: "20px" }}>
                    UEC
                </ResponsiveHeader>
                <ResponsiveFooter width="20%">
                    <AddElementButton onAddElementClick={handleAddElementClick} />
                </ResponsiveFooter>

                {elementRows}

                <ResponsiveHeader width="40%"/>
                <ResponsiveHeader width="20%"/>
                <RockTotals width="20%" style={{ paddingRight: "20px" }}>
                    Total
                    <RockValue elements={elements} />
                </RockTotals>
                <ResponsiveCell width="20%">
                    <ClearRockButton />
                </ResponsiveCell>
            </RockTable>
        </Form>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(RockForm));